export const DocumentTemplateElementOptions = [
  {label: 'Single-line text', value: 'TextInput'},
  {label: 'Multi-line text', value: 'MultiLineTextInput'},
  {label: 'Phone Number', value: 'PhoneNumberInput'},
  {label: 'Date', value: 'DateInput'},
  {label: 'Social security number', value: 'SsnInput'},
  {label: 'Email', value: 'EmailInput'},
  {label: 'Address', value: 'AddressInput'},
  {label: 'Currency', value: 'CurrencyInput'},
  {label: 'Date & Time', value: 'DateTimeInput'},
  {label: 'Time', value: 'TimeInput'},
  {label: 'Rating', value: 'RatingInput'},
  {label: 'Signature', value: 'SignatureInput'},
  {label: 'Signature & Date', value: 'SignatureDateInput'},
  {label: 'Checkbox', value: 'CheckboxInput'},
  {label: 'Website (URL)', value: 'UrlInput'},
  {label: 'Yes/No', value: 'YesNoInput'},
  {label: 'Dropdown', value: 'Dropdown'},
];
